import React from 'react';

import { Footer, Header } from '$partials/global';
import { SimpleImage } from '$partials/media';
import OfficeListing from '$partials/offices/office-listing';
import { CtaBannerBlock } from '$partials/modules/blocks';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 *
 * @type {import('$types/components/pages').OfficeListingPage}
 */
const OfficeListingPage = (props) => {
    const page = props.data.page;

    return (
        <>
            <Header {...props.data.header} />

            <main id='main-content'>
                <header className='theme-light-alt bg-main-background'>
                    <div className='layout-container layout-site-outer-padding pb-24 sm:pb-40 md:pt-160 md:pb-48'>
                        <h1 className='text-main-text-primary type-style-1'>
                            {page?.title}
                        </h1>
                    </div>
                    {page?.coverImage && (
                        <SimpleImage
                            className='hidden md:block w-full md:h-[810px] object-cover'
                            {...page.coverImage}/>
                    )}
                </header>
                <section>
                    <OfficeListing markets={page.markets}/>
                </section>
            </main>

            <CtaBannerBlock
                body={props.data.footer?.getInTouchBodyText}
                heading={props.data.footer?.getInTouchHeadingText}
                opensDialog={true}/>
            <Footer {...props.data.footer} />
        </>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default OfficeListingPage;
